import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTemplates(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/contract_template/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchTemplate(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/contract_template`, {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addTemplate(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/contract_template', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deleteTemplate(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/contract_template', {params:data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLanguages(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/contract_template_language/list', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
  },
    

  },
}
